export const PROMO_CODE_DISCOUNT_TYPE_ENUM = {
  PERCENTAGE: 1,
  NOMINAL: 2
}
